import { Component } from 'preact';

import s from './style.css';
import Container from 'components/Container';
import NextArrow from 'components/NextArrow';
import LoveHeart from 'components/LoveHeart';

class Intro extends Component {
	constructor(props) {
		super(props);
		this.onDrag = this.onDrag.bind(this);

		this.state = {
			dragging: null,
			text: [
				{
					x: 428,
					y: 288,
					style: 1,
					rotation: 0,
					text: 'Lose',
					text2: 'CTRL'
				},
				{
					x: 861,
					y: 282,
					style: 3,
					rotation: 20,
					text: 'Adobe',
					text2: 'mine'
				},
				{
					x: 730,
					y: -456,
					style: 2,
					rotation: 3,
					text: 'Firefoxy',
					text2: 'lady'
				},
				{
					x: -529,
					y: 36,
					style: 4,
					rotation: -10,
					text: 'Outlook',
					text2: 'me up'
				},
				{
					x: -412,
					y: -380,
					style: 1,
					rotation: 6,
					text: 'Find',
					text2: 'me'
				},
				{
					x: -584,
					y: 186,
					style: 2,
					rotation: -30,
					text: 'Word',
					text2: 'up'
				},
				{
					x: -585,
					y: -347,
					style: 3,
					rotation: 16,
					text: 'Email',
					text2: 'me'
				},
				{
					x: 860,
					y: -402,
					style: 1,
					rotation: -5,
					text: 'Skype',
					text2: 'me'
				},
				{
					x: 555,
					y: -174,
					style: 3,
					rotation: 4,
					text: 'Call',
					text2: 'HR'
				},
				{
					x: -152,
					y: -337,
					style: 1,
					rotation: 11,
					text: 'Lose',
					text2: 'CTRL'
				},
				{
					x: -276,
					y: 197,
					style: 2,
					rotation: -10,
					text: 'Adobe',
					text2: 'mine'
				},
				{
					x: -270,
					y: -446,
					style: 3,
					rotation: 6,
					text: 'Firefoxy',
					text2: 'lady'
				},
				{
					x: -359,
					y: 87,
					style: 3,
					rotation: 8,
					text: 'Outlook',
					text2: 'me up'
				},
				{
					x: -294,
					y: -62,
					style: 1,
					rotation: -22,
					text: 'Find',
					text2: 'me'
				},
				{
					x: 822,
					y: 113,
					style: 2,
					rotation: -3,
					text: 'Word',
					text2: 'up'
				},
				{
					x: -415,
					y: 272,
					style: 1,
					rotation: 11,
					text: 'Email',
					text2: 'me'
				},
				{
					x: 856,
					y: -99,
					style: 4,
					rotation: 4,
					text: 'Skype',
					text2: 'me'
				},
				{
					x: 646,
					y: 209,
					style: 1,
					rotation: 17,
					text: 'Call',
					text2: 'HR'
				},
				{
					x: -158,
					y: 271,
					style: 4,
					rotation: -3,
					text: 'Lose',
					text2: 'CTRL'
				},
				{
					x: 718,
					y: -126,
					style: 2,
					rotation: 8,
					text: 'Adobe',
					text2: 'mine'
				},
				{
					x: 732,
					y: 1,
					style: 3,
					rotation: -4,
					text: 'Firefoxy',
					text2: 'lady'
				},
				{
					x: -319,
					y: -276,
					style: 2,
					rotation: -6,
					text: 'Outlook',
					text2: 'me up'
				},
				{
					x: 674,
					y: -255,
					style: 1,
					rotation: 30,
					text: 'Find',
					text2: 'me'
				},
				{
					x: 589,
					y: 42,
					style: 4,
					rotation: 20,
					text: 'Word',
					text2: 'up'
				},
				{
					x: -435,
					y: -96,
					style: 3,
					rotation: 10,
					text: 'Email',
					text2: 'me'
				},
				{
					x: 480,
					y: -51,
					style: 2,
					rotation: -20,
					text: 'Skype',
					text2: 'me'
				},
				{
					x: -12,
					y: -471,
					style: 1,
					rotation: 22,
					text: 'Call',
					text2: 'HR'
				},
				{
					x: -150,
					y: 105,
					style: 1,
					rotation: 4,
					text: 'Lose',
					text2: 'CTRL'
				},
				{
					x: 470,
					y: 106,
					style: 3,
					rotation: -6,
					text: 'Adobe',
					text2: 'mine'
				},
				{
					x: -154,
					y: -78,
					style: 2,
					rotation: 5,
					text: 'Firefoxy',
					text2: 'lady'
				},
				{
					x: -125,
					y: -213,
					style: 4,
					rotation: 13,
					text: 'Outlook',
					text2: 'me up'
				},
				{
					x: 417,
					y: -253,
					style: 1,
					rotation: -13,
					text: 'Find',
					text2: 'me'
				},
				{
					x: 854,
					y: -254,
					style: 2,
					rotation: 3,
					text: 'Word',
					text2: 'up'
				},
				{
					x: 592,
					y: -395,
					style: 4,
					rotation: 8,
					text: 'Email',
					text2: 'me'
				},
				{
					x: 615,
					y: 319,
					style: 3,
					rotation: 26,
					text: 'Skype',
					text2: 'me'
				},
				{
					x: -560,
					y: -187,
					style: 1,
					rotation: -18,
					text: 'Call',
					text2: 'HR'
				},
				{
					x: 828,
					y: -164,
					style: 1,
					rotation: -6,
					isSparkle: true
				},
				{
					x: -86,
					y: -410,
					style: 1,
					rotation: 6,
					isSparkle: true
				},
				{
					x: -321,
					y: -145,
					style: 1,
					rotation: 2,
					isSparkle: true
				},
				{
					x: -444,
					y: -264,
					style: 1,
					rotation: 3,
					isSparkle: true
				},
				{
					x: 447,
					y: -343,
					style: 1,
					rotation: 10,
					isSparkle: true
				},
				{
					x: 770,
					y: -327,
					style: 1,
					rotation: -20,
					isSparkle: true
				},
				{
					x: -377,
					y: -2,
					style: 1,
					rotation: 5,
					isSparkle: true
				},
				{
					x: -429,
					y: 171,
					style: 1,
					rotation: -6,
					isSparkle: true
				},
				{
					x: -232,
					y: 70,
					style: 1,
					rotation: 6,
					isSparkle: true
				},
				{
					x: 573,
					y: -258,
					style: 1,
					rotation: 16,
					isSparkle: true
				},
				{
					x: -178,
					y: -138,
					style: 1,
					rotation: -16,
					isSparkle: true
				},
				{
					x: 577,
					y: 283,
					style: 1,
					rotation: 12,
					isSparkle: true
				},
				{
					x: 780,
					y: 248,
					style: 1,
					rotation: -6,
					isSparkle: true
				},
				{
					x: 581,
					y: 163,
					style: 1,
					rotation: 6,
					isSparkle: true
				},
				{
					x: 729,
					y: 122,
					style: 1,
					rotation: 2,
					isSparkle: true
				},
				{
					x: 622,
					y: -41,
					style: 1,
					rotation: 3,
					isSparkle: true
				},
				{
					x: 24,
					y: 285,
					style: 1,
					rotation: 10,
					isSparkle: true
				},
				{
					x: -276,
					y: 305,
					style: 1,
					rotation: -20,
					isSparkle: true
				},
				{
					x: -79,
					y: 16,
					style: 1,
					rotation: 5,
					isSparkle: true
				},
				{
					x: 38,
					y: -60,
					style: 1,
					rotation: -6,
					isSparkle: true
				},
				{
					x: 421,
					y: 190,
					style: 1,
					rotation: 6,
					isSparkle: true
				},
				{
					x: -527,
					y: 311,
					style: 1,
					rotation: 16,
					isSparkle: true
				},
				{
					x: 436,
					y: -100,
					style: 1,
					rotation: -16,
					isSparkle: true
				},
				{
					x: 321,
					y: 335,
					style: 1,
					rotation: 12,
					isSparkle: true
				},
				{
					isMobile: true,
					x: -103,
					y: 272,
					style: 1,
					rotation: 30,
					text: 'Lose',
					text2: 'CTRL'
				},
				{
					isMobile: true,
					x: 351,
					y: 145,
					style: 3,
					rotation: -30,
					text: 'Adobe',
					text2: 'mine'
				},
				{
					isMobile: true,
					x: 248,
					y: -328,
					style: 2,
					rotation: 10,
					text: 'Firefoxy',
					text2: 'lady'
				},
				{
					isMobile: true,
					x: 186,
					y: 285,
					style: 4,
					rotation: 20,
					text: 'Outlook',
					text2: 'me up'
				},
				{
					isMobile: true,
					x: 334,
					y: 22,
					style: 1,
					rotation: 7,
					text: 'Find',
					text2: 'me'
				},
				{
					isMobile: true,
					x: 244,
					y: 229,
					style: 2,
					rotation: -7,
					text: 'Word',
					text2: 'up'
				},
				{
					isMobile: true,
					x: -99,
					y: 91,
					style: 3,
					rotation: 12,
					text: 'Email',
					text2: 'me'
				},
				{
					isMobile: true,
					x: 252,
					y: -56,
					style: 1,
					rotation: 15,
					text: 'Skype',
					text2: 'me'
				},
				{
					isMobile: true,
					x: -31,
					y: -68,
					style: 3,
					rotation: -11,
					text: 'Call',
					text2: 'HR'
				},
				{
					isMobile: true,
					x: -87,
					y: -203,
					style: 1,
					rotation: -22,
					text: 'Lose',
					text2: 'CTRL'
				},
				{
					isMobile: true,
					x: -122,
					y: -40,
					style: 2,
					rotation: 6,
					text: 'Adobe',
					text2: 'mine'
				},
				{
					isMobile: true,
					x: -21,
					y: 234,
					style: 3,
					rotation: 8,
					text: 'Firefoxy',
					text2: 'lady'
				},
				{
					isMobile: true,
					x: 350,
					y: -93,
					style: 3,
					rotation: 2,
					text: 'Outlook',
					text2: 'me up'
				},
				{
					isMobile: true,
					x: 43,
					y: 302,
					style: 1,
					rotation: -6,
					text: 'Find',
					text2: 'me'
				},
				{
					isMobile: true,
					x: -119,
					y: -115,
					style: 1,
					rotation: -6,
					isSparkle: true
				},
				{
					isMobile: true,
					x: -119,
					y: 303,
					style: 1,
					rotation: 6,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 368,
					y: 316,
					style: 1,
					rotation: 2,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 151,
					y: 315,
					style: 1,
					rotation: 3,
					isSparkle: true
				},
				{
					isMobile: true,
					x: -51,
					y: 178,
					style: 1,
					rotation: 10,
					isSparkle: true
				},
				{
					isMobile: true,
					x: -57,
					y: 39,
					style: 1,
					rotation: -20,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 326,
					y: 107,
					style: 1,
					rotation: 5,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 312,
					y: -33,
					style: 1,
					rotation: -6,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 220,
					y: -9,
					style: 1,
					rotation: 6,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 68,
					y: 247,
					style: 1,
					rotation: 16,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 338,
					y: -159,
					style: 1,
					rotation: -16,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 62,
					y: -17,
					style: 1,
					rotation: 12,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 67,
					y: -338,
					style: 1,
					rotation: -5,
					isSparkle: true
				},
				{
					isMobile: true,
					x: 208,
					y: -332,
					style: 1,
					rotation: 5,
					isSparkle: true
				},
				{
					isMobile: true,
					x: -26,
					y: -356,
					style: 4,
					rotation: 12,
					text: 'Outlook',
					text2: 'me up'
				}
			]
		};
	}

	startDragging(e, i, enabled) {
		const { text } = this.state;

		if (!enabled) {
			return;
		}

		this.setState({
			dragging: i,
			startX: e.clientX,
			startY: e.clientY,
			initialX: text[i].x,
			initialY: text[i].y
		});
	}

	stopDragging(i) {
		this.setState({
			dragging: null,
			startX: null,
			startY: null
		});
	}

	onDrag(e) {
		const { text, dragging, startX, startY, initialX, initialY } = this.state;
		if (dragging !== null) {
			text[dragging].x = initialX + e.clientX - startX;
			text[dragging].y = initialY + e.clientY - startY;

			this.setState({
				text
			});
		}
	}

	render() {
		const { text } = this.state;
		const textWithId = text.map((item, i) => ({ ...item, id: i }));

		const mobileHearts = textWithId.filter(
			({ isMobile, isSparkle }) => isMobile && !isSparkle
		);
		const loveHearts = textWithId.filter(
			({ isMobile, isSparkle }) => !isMobile && !isSparkle
		);

		const mobileSparkles = textWithId.filter(
			({ isMobile, isSparkle }) => isMobile && isSparkle
		);
		const loveSparkles = textWithId.filter(
			({ isMobile, isSparkle }) => !isMobile && isSparkle
		);

		return (
			<div className={s.root} onMouseMove={this.onDrag}>
				<Container>
					<h1>
						<svg
							width="385"
							height="353"
							className={s.image}
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 329 302"
						>
							<title>
								How love works – The secrets of the UK's workplace romances
							</title>
							<path
								d="M286 300.1l-10.2-15.4a5.6 5.6 0 0 1 0-6.2L286 263a115.8 115.8 0 0 1-45.8-8.9v37.2a116.2 116.2 0 0 0 45.8 8.8z"
								fill="#ffdfc1"
							/>
							<path
								fill="#feb36c"
								d="M266.7 273.5l-26.4 18v-38.7l26.4-17.9v38.6z"
							/>
							<path
								d="M14 234.6l10.4-15.4a5.6 5.6 0 0 0 0-6.3L14 197.5a116 116 0 0 0 45.7-9v37.2a115.8 115.8 0 0 1-45.7 9z"
								fill="#ffdfc1"
							/>
							<path
								fill="#feb36c"
								d="M33.4 208l26.4 17.9v-38.6l-26.4-18V208zm36.9 7.7l224-46.5v38.6l-224 46.3v-38.4z"
							/>
							<path
								d="M303 30.2a93 93 0 0 0-139.2 2.4 93 93 0 1 0-133.5 129l133.5 129.5 133.5-129.5A93 93 0 0 0 303 30.2z"
								fill="#e74347"
							/>
							<path
								d="M33.4 207.8a169.9 169.9 0 0 1 130.5 0 169.9 169.9 0 0 0 130.4 0v-38.5a169.9 169.9 0 0 1-130.4 0 169.8 169.8 0 0 0-130.5 0z"
								fill="#feca98"
							/>
							<path
								d="M70.3 254.1a169.7 169.7 0 0 1 93.6 10.7 169.8 169.8 0 0 0 102.8 8.7v-38.4a169.8 169.8 0 0 1-102.9-8.8 169.7 169.7 0 0 0-93.6-10.6"
								fill="#feca98"
							/>
							<path
								d="M286.1 300l-10.3-15.5a5.6 5.6 0 0 1 0-6.2l10.3-15.5a116.1 116.1 0 0 1-45.7-8.9v37.2A116 116 0 0 0 286 300z"
								fill="#ffdfc1"
							/>
							<path
								fill="#feb36c"
								d="M266.8 273.3l-26.4 18v-38.7l26.4-17.9v38.6z"
							/>
							<path
								d="M14 234.4l10.3-15.5a5.6 5.6 0 0 0 0-6.2L14 197.3a116 116 0 0 0 45.8-9v37.2a116 116 0 0 1-45.8 8.9z"
								fill="#ffdfc1"
							/>
							<path
								fill="#feb36c"
								d="M33.4 207.8l26.4 17.9v-38.6l-26.4-18v38.7zm36.8 7.6l224.2-46.5v38.7L70.2 253.9v-38.5z"
							/>
							<path
								d="M303 30a93 93 0 0 0-131.4-5.7 94.4 94.4 0 0 0-7.8 8 94.4 94.4 0 0 0-7.7-8 93 93 0 0 0-125.9 137L163.8 291l133.6-129.7A93 93 0 0 0 303 30z"
								fill="#e74347"
							/>
							<path
								d="M33.4 207.6a170 170 0 0 1 130.5 0 170 170 0 0 0 130.5 0V169a170 170 0 0 1-130.5 0 170 170 0 0 0-130.6 0z"
								fill="#feca98"
							/>
							<path d="M77.6 180.2a1.9 1.9 0 0 0 .1.4.5.5 0 0 0 .2.3.4.4 0 0 0 .2 0 1.3 1.3 0 0 0 .3 0h.6l.1.7-4.8.7v-.8h.5l.3-.1a.5.5 0 0 0 .2-.2.6.6 0 0 0 .1-.3 2 2 0 0 0 0-.4l-1-7.5-1.1.2a1.6 1.6 0 0 0-.5.1.9.9 0 0 0-.3.3.7.7 0 0 0-.2.3 2 2 0 0 0 0 .4v.9l-1 .1-.2-2.7 8.6-1.1.5 2.7h-1l-.2-.8a2 2 0 0 0-.1-.4.8.8 0 0 0-.3-.3 1 1 0 0 0-.3-.1 2 2 0 0 0-.6 0l-1 .1zm9.6.7l-.1-.8h.6a.8.8 0 0 0 .3-.1.4.4 0 0 0 .2-.1.6.6 0 0 0 .1-.3 1.4 1.4 0 0 0 0-.5l-.2-3.1-3.6.3.2 3a1.4 1.4 0 0 0 0 .6.7.7 0 0 0 .3.2.7.7 0 0 0 .2.1h.9v.8l-4.8.3v-.7h.5a1.2 1.2 0 0 0 .3 0 .5.5 0 0 0 .2-.2.6.6 0 0 0 .2-.3 1.4 1.4 0 0 0 0-.5l-.5-6.8a1.2 1.2 0 0 0 0-.4.6.6 0 0 0-.3-.3.5.5 0 0 0-.2 0 1.2 1.2 0 0 0-.3 0h-.6v-.8l4.8-.3v.7H85a1.3 1.3 0 0 0-.3.1.4.4 0 0 0-.2.1.7.7 0 0 0-.2.3 1.4 1.4 0 0 0 0 .5l.2 2.7 3.7-.3-.2-2.7a2.3 2.3 0 0 0-.1-.4.8.8 0 0 0-.2-.3.5.5 0 0 0-.2-.1h-1v-.8l4.8-.3v.7h-.6a.8.8 0 0 0-.2 0 .4.4 0 0 0-.3.2.6.6 0 0 0 0 .3 1.4 1.4 0 0 0 0 .5l.4 6.7a1.1 1.1 0 0 0 0 .5.6.6 0 0 0 .3.2.5.5 0 0 0 .2.1 1.2 1.2 0 0 0 .3 0h.5l.1.7zm8.8-1.2h2.8a.8.8 0 0 0 .4-.1.7.7 0 0 0 .2-.3 1 1 0 0 0 .2-.3 1.8 1.8 0 0 0 0-.4l.2-.7h1v2.6h-8.3v-.6h.5a1.1 1.1 0 0 0 .3 0 .5.5 0 0 0 .2-.2.4.4 0 0 0 .2-.2 1.4 1.4 0 0 0 0-.5l-.1-6.7a1.6 1.6 0 0 0 0-.5.7.7 0 0 0-.2-.3.5.5 0 0 0-.3-.1 1.3 1.3 0 0 0-.2 0h-.6v-.7l7.7-.1.1 2.5h-1v-.6a1.6 1.6 0 0 0-.3-.8.8.8 0 0 0-.7-.3h-2.3v3.5h3.3v.9h-3.3zm12.2 1.2a5.7 5.7 0 0 1-1.6-.3 3 3 0 0 1-1-.5 1.8 1.8 0 0 1-.5-.6 1.6 1.6 0 0 1-.1-.7 1.2 1.2 0 0 1 .2-.6 1 1 0 0 1 .3-.4 1.5 1.5 0 0 1 .6-.2 2.9 2.9 0 0 1 .5 0 3.5 3.5 0 0 0 .1 1 2.1 2.1 0 0 0 .4.8 1.6 1.6 0 0 0 .6.5 2 2 0 0 0 .7.2 2.5 2.5 0 0 0 .7 0 1.7 1.7 0 0 0 .6-.3 1.4 1.4 0 0 0 .4-.5 1.5 1.5 0 0 0 .1-.6 1.3 1.3 0 0 0 0-.6 1.5 1.5 0 0 0-.5-.6 3.7 3.7 0 0 0-.7-.5l-1-.5a8.4 8.4 0 0 1-1.2-.7 3.6 3.6 0 0 1-.7-.7 2.3 2.3 0 0 1-.4-.8 3.2 3.2 0 0 1-.1-1 2.6 2.6 0 0 1 .3-1.1 2.7 2.7 0 0 1 .8-.9 3.6 3.6 0 0 1 1.1-.5 4.8 4.8 0 0 1 1.4-.1 5.9 5.9 0 0 1 1.3.2 3 3 0 0 1 1 .4 1.6 1.6 0 0 1 .4.6 1.4 1.4 0 0 1 .2.6 1 1 0 0 1-.2.5 1 1 0 0 1-.3.3 1.7 1.7 0 0 1-.6.2 3.5 3.5 0 0 1-.7 0 3.6 3.6 0 0 0 0-.6 2.3 2.3 0 0 0-.2-.7 1.6 1.6 0 0 0-.5-.5 1.2 1.2 0 0 0-.6-.2 1.6 1.6 0 0 0-.6 0 1 1 0 0 0-.4.3 1.2 1.2 0 0 0-.4.4 1.5 1.5 0 0 0-.1.5 1.5 1.5 0 0 0 0 .6 1.4 1.4 0 0 0 .4.5 3 3 0 0 0 .7.5 9.8 9.8 0 0 0 1 .6 9 9 0 0 1 1.3.7 4 4 0 0 1 .8.7 2.2 2.2 0 0 1 .4.8 3 3 0 0 1-.3 2.2 2.7 2.7 0 0 1-.8.9 3.6 3.6 0 0 1-1.2.6 5.3 5.3 0 0 1-1.6.1zm8.2-.3l2.8.3a.7.7 0 0 0 .4 0 .7.7 0 0 0 .3-.2 1.2 1.2 0 0 0 .2-.3 2.6 2.6 0 0 0 .1-.4l.2-.7 1 .2-.4 2.5-8.2-1 .1-.7.6.1h.3a.5.5 0 0 0 .2 0 .6.6 0 0 0 .2-.3 1.3 1.3 0 0 0 .1-.4l.8-6.8a1.3 1.3 0 0 0 0-.5.6.6 0 0 0-.1-.2.4.4 0 0 0-.3-.2 1 1 0 0 0-.2 0l-.6-.1v-.8l7.8 1-.2 2.5-1-.1v-.7a1.5 1.5 0 0 0-.2-.8.7.7 0 0 0-.6-.3l-2.4-.3-.3 3.5 3.3.3-.1.9-3.3-.4zm10.9 1.4a3.2 3.2 0 0 0 1.6-.1 3.2 3.2 0 0 0 .6-.4 5.3 5.3 0 0 0 .5-.4.6.6 0 0 1 .2.3 1 1 0 0 1 0 .4 1.3 1.3 0 0 1-.3.5 1.6 1.6 0 0 1-.6.5 3 3 0 0 1-1 .3 5.4 5.4 0 0 1-1.5 0 5.7 5.7 0 0 1-2-.8 4 4 0 0 1-1.3-1.2 4.3 4.3 0 0 1-.6-1.8 6.6 6.6 0 0 1 0-2.1 6.4 6.4 0 0 1 .6-2 4.4 4.4 0 0 1 1.2-1.5 4.2 4.2 0 0 1 1.6-.8 5.6 5.6 0 0 1 2.2 0 6.8 6.8 0 0 1 1.3.4 3.4 3.4 0 0 1 1 .5 1.7 1.7 0 0 1 .4.6 1.3 1.3 0 0 1 .1.7 1 1 0 0 1-.2.4 1.2 1.2 0 0 1-.3.4 1.9 1.9 0 0 1-.6.1 2.8 2.8 0 0 1-.8 0 3.2 3.2 0 0 0 0-.7 1.8 1.8 0 0 0-.1-.6 1.5 1.5 0 0 0-.4-.6 1.4 1.4 0 0 0-.7-.3 2 2 0 0 0-2 .8 4.3 4.3 0 0 0-.6 1.3 11.4 11.4 0 0 0-.5 1.7 9 9 0 0 0-.1 1.8 3.7 3.7 0 0 0 .3 1.3 2.1 2.1 0 0 0 .7.9 3 3 0 0 0 1.3.4zm3.4.8l.6.2h.3a.5.5 0 0 0 .2-.1.5.5 0 0 0 .2-.2 1.4 1.4 0 0 0 .2-.4l1.5-6.7a1.5 1.5 0 0 0 0-.4.6.6 0 0 0-.1-.3.4.4 0 0 0-.2-.2 1.1 1.1 0 0 0-.3 0l-.5-.2.1-.7 4.4 1a5 5 0 0 1 2.7 1.3 2.2 2.2 0 0 1 .5 2 2.8 2.8 0 0 1-.4 1 2.4 2.4 0 0 1-.6.6 3 3 0 0 1-.7.4 4.5 4.5 0 0 1-.7.2l1 3.2a4.7 4.7 0 0 0 .2.6 2.7 2.7 0 0 0 .2.4 1 1 0 0 0 .3.3 1 1 0 0 0 .4.1l-.1.7h-.5a10.4 10.4 0 0 1-1-.4 3 3 0 0 1-.8-.3 2 2 0 0 1-.5-.5 3 3 0 0 1-.3-.8l-1-3.3-.9-.2-.6 2.6a1.5 1.5 0 0 0 0 .5.5.5 0 0 0 .3.4l.3.1.5.2-.1.7-4.7-1.1zm4.4-3.5l.8.2a2.1 2.1 0 0 0 .8 0 1.1 1.1 0 0 0 .6-.2 1.6 1.6 0 0 0 .4-.6 4.1 4.1 0 0 0 .3-.8 4 4 0 0 0 .1-1 1.5 1.5 0 0 0-.2-.6 1.2 1.2 0 0 0-.4-.5 2.6 2.6 0 0 0-.7-.2l-.8-.2zm8.5 6.6l2.7.7a.8.8 0 0 0 .3 0 .8.8 0 0 0 .3-.1 1.3 1.3 0 0 0 .3-.3 2 2 0 0 0 .2-.4l.3-.6 1 .3-.9 2.4-7.8-2.2.2-.7.6.2h.2a.5.5 0 0 0 .3 0 .5.5 0 0 0 .2-.2 1.3 1.3 0 0 0 .2-.4l1.9-6.5a2.1 2.1 0 0 0 0-.5.7.7 0 0 0 0-.3.6.6 0 0 0-.2-.2 1.7 1.7 0 0 0-.3-.1l-.6-.2.3-.7 7.4 2.1-.6 2.5-1-.2.1-.7a1.6 1.6 0 0 0 0-.8.8.8 0 0 0-.5-.5l-2.3-.6-1 3.4 3.2.9-.2.8-3.2-1zm10.4 2.4a1.4 1.4 0 0 0-.1.5.6.6 0 0 0 0 .3.4.4 0 0 0 .2.2 1.5 1.5 0 0 0 .3.1l.5.2-.2.7-4.6-1.6.3-.7.5.2a1.1 1.1 0 0 0 .3.1.5.5 0 0 0 .3 0 .6.6 0 0 0 .2-.3 2 2 0 0 0 .2-.4l2.4-7-1-.4a1.6 1.6 0 0 0-.5-.1 1 1 0 0 0-.4 0 .8.8 0 0 0-.3.3 2 2 0 0 0-.2.3l-.4.8-1-.3 1-2.5 8.3 2.8-.8 2.6-.9-.3.2-.9a1.6 1.6 0 0 0 0-.4.7.7 0 0 0 0-.3 1 1 0 0 0-.3-.3 1.8 1.8 0 0 0-.5-.3l-1-.3zm5.9 4.1a5.7 5.7 0 0 1-1.4-.7 3.1 3.1 0 0 1-.8-.8 1.6 1.6 0 0 1-.2-.8 1.6 1.6 0 0 1 0-.7 1.3 1.3 0 0 1 .4-.5 1 1 0 0 1 .5-.2 1.4 1.4 0 0 1 .6 0 3 3 0 0 1 .5.1 3.4 3.4 0 0 0-.2 1 2.1 2.1 0 0 0 0 .9 1.6 1.6 0 0 0 .4.6 1.9 1.9 0 0 0 .7.4 2 2 0 0 0 .7.2 1.6 1.6 0 0 0 .7 0 1.5 1.5 0 0 0 .5-.4 1.5 1.5 0 0 0 .3-.5 1.5 1.5 0 0 0 0-.7 1.7 1.7 0 0 0-.1-.6 3.6 3.6 0 0 0-.5-.7l-.8-.8a8.8 8.8 0 0 1-.9-1 3.5 3.5 0 0 1-.5-1 2.5 2.5 0 0 1-.1-.8 3.3 3.3 0 0 1 .2-1 2.6 2.6 0 0 1 .7-1 2.7 2.7 0 0 1 1-.5 3.5 3.5 0 0 1 1.2-.2 5 5 0 0 1 1.4.4 6.9 6.9 0 0 1 1.2.6 3.2 3.2 0 0 1 .7.7 1.6 1.6 0 0 1 .3.6 1.3 1.3 0 0 1 0 .7 1.4 1.4 0 0 1-.3.4 1.2 1.2 0 0 1-.5.2 1.6 1.6 0 0 1-.6 0 2.9 2.9 0 0 1-.7-.2 2.8 2.8 0 0 0 .2-.6 2.2 2.2 0 0 0 0-.7 1.4 1.4 0 0 0-.3-.6 1.1 1.1 0 0 0-.6-.4 1.6 1.6 0 0 0-.5-.2 1 1 0 0 0-.5.1 1.1 1.1 0 0 0-.4.3 1.3 1.3 0 0 0-.3.4 1.4 1.4 0 0 0 0 1.2 3.8 3.8 0 0 0 .5.7 10 10 0 0 0 .8 1 9.7 9.7 0 0 1 1 1 4 4 0 0 1 .5.9 2 2 0 0 1 .1.9 2.7 2.7 0 0 1-.2.9 3 3 0 0 1-.7 1 2.7 2.7 0 0 1-1 .6 3.7 3.7 0 0 1-1.4.2 5.3 5.3 0 0 1-1.6-.4zM179 194a7 7 0 0 1-1 2 4.7 4.7 0 0 1-1.4 1.2 4 4 0 0 1-1.7.5 5.2 5.2 0 0 1-2-.3 5.7 5.7 0 0 1-1.9-1 3.9 3.9 0 0 1-1-1.5 4.3 4.3 0 0 1-.4-1.8 7.6 7.6 0 0 1 1.4-4 4.3 4.3 0 0 1 1.3-1.2 3.8 3.8 0 0 1 1.8-.5 5.5 5.5 0 0 1 2 .3 5 5 0 0 1 1.9 1 3.9 3.9 0 0 1 1 1.5 4.5 4.5 0 0 1 .4 1.8 7.2 7.2 0 0 1-.4 2zm-6.8-2.2a10.2 10.2 0 0 0-.4 1.7 4.2 4.2 0 0 0 0 1.4 2.1 2.1 0 0 0 .4 1 2.3 2.3 0 0 0 2.1.7 2.1 2.1 0 0 0 1-.5 4.2 4.2 0 0 0 .8-1.2 11.5 11.5 0 0 0 .7-1.6 12 12 0 0 0 .5-1.8 4.4 4.4 0 0 0 0-1.3 2 2 0 0 0-1.4-1.7 2 2 0 0 0-1.1 0 2.1 2.1 0 0 0-1 .5 4.5 4.5 0 0 0-.9 1 10.8 10.8 0 0 0-.6 1.8zm15.2 2.1l.1-.7a1.2 1.2 0 0 0 0-.9 1 1 0 0 0-.7-.4l-2.1-.6-1 3.7 3.2.9-.3.8-3.2-.9-.7 2.7a2 2 0 0 0 0 .5.7.7 0 0 0 0 .3.4.4 0 0 0 .2.2 1 1 0 0 0 .2.1l.9.2-.2.8-5-1.4.3-.7.5.1a1.5 1.5 0 0 0 .3 0 .5.5 0 0 0 .3 0 .6.6 0 0 0 .2-.2 1.8 1.8 0 0 0 .1-.4l1.8-6.5a1.4 1.4 0 0 0 .1-.5.5.5 0 0 0-.3-.5 1.6 1.6 0 0 0-.2 0l-.6-.2.2-.7 7.5 2-.6 2.5zm9.2 7.9a1.7 1.7 0 0 0 0 .5.5.5 0 0 0 .1.3.5.5 0 0 0 .2.1 1 1 0 0 0 .3.1l.6.1-.2.8-4.7-1 .1-.7.6.1a1 1 0 0 0 .3 0 .4.4 0 0 0 .2 0 .6.6 0 0 0 .2-.3 1.7 1.7 0 0 0 .2-.5l1.4-7.3-1-.2a1.7 1.7 0 0 0-.6 0 1 1 0 0 0-.4.1 1 1 0 0 0-.3.3 1.8 1.8 0 0 0-.1.4l-.3.8-1-.2.7-2.6 8.6 1.7-.5 2.6-1-.1.1-1a2 2 0 0 0 0-.4.8.8 0 0 0-.1-.3.9.9 0 0 0-.3-.3 1.7 1.7 0 0 0-.5-.1l-1.1-.2zm9.6 3.2v-.7h.7a1 1 0 0 0 .3 0 .5.5 0 0 0 .2 0 .7.7 0 0 0 .2-.3 2 2 0 0 0 .1-.5l.4-3-3.6-.6-.4 3.1a1.5 1.5 0 0 0 0 .5.7.7 0 0 0 0 .3.7.7 0 0 0 .3.2h.3l.6.1-.1.8-4.8-.7v-.7h1a.5.5 0 0 0 .3 0 .9.9 0 0 0 .2-.3 1.9 1.9 0 0 0 .1-.5l.9-6.6a1.4 1.4 0 0 0 0-.5.5.5 0 0 0-.1-.3.5.5 0 0 0-.2-.1.8.8 0 0 0-.3 0l-.6-.2.1-.7 4.8.6v.8h-.7a.9.9 0 0 0-.3 0 .4.4 0 0 0-.2 0 .7.7 0 0 0-.2.3 1.8 1.8 0 0 0-.1.4l-.4 2.7 3.6.5.4-2.7a1.6 1.6 0 0 0 0-.5.6.6 0 0 0-.1-.3.7.7 0 0 0-.2-.1 1.1 1.1 0 0 0-.3 0l-.6-.2.1-.7 4.8.7-.1.7-.6-.1h-.3a.5.5 0 0 0-.2 0 .6.6 0 0 0-.2.3 2 2 0 0 0-.1.5l-1 6.7a1.7 1.7 0 0 0 0 .5.6.6 0 0 0 .2.2.6.6 0 0 0 .2.2 1.1 1.1 0 0 0 .3 0l.6.1-.1.7zm9.4.2l2.8.2a.7.7 0 0 0 .4 0 .7.7 0 0 0 .3-.3 1.4 1.4 0 0 0 .2-.3 4.2 4.2 0 0 0 .1-.4l.2-.7h1l-.3 2.7-8.2-.6v-.8h.6a1.3 1.3 0 0 0 .3 0 .5.5 0 0 0 .2 0 .5.5 0 0 0 .2-.3 2 2 0 0 0 .1-.5l.5-6.7a1.8 1.8 0 0 0 0-.5.7.7 0 0 0-.1-.3.5.5 0 0 0-.2-.1h-.9v-.8l7.8.6-.1 2.5h-1v-.7a1.6 1.6 0 0 0-.2-.8.8.8 0 0 0-.7-.3l-2.3-.2-.3 3.5 3.4.2-.1.9-3.3-.3zm19.4-7.9h-.6a.8.8 0 0 0-.3 0 .5.5 0 0 0-.2 0 .6.6 0 0 0-.1.3 1.3 1.3 0 0 0-.1.5v5.5a3.5 3.5 0 0 1-.2 1.3 2.3 2.3 0 0 1-.6 1 3 3 0 0 1-1.1.5 5.6 5.6 0 0 1-1.6.3 6.8 6.8 0 0 1-1.6-.2 3 3 0 0 1-1.2-.6 2.5 2.5 0 0 1-.8-1 3.6 3.6 0 0 1-.3-1.4V198a1.4 1.4 0 0 0 0-.4.6.6 0 0 0-.2-.3.5.5 0 0 0-.2 0 1.2 1.2 0 0 0-.3 0h-.6v-.8h4.8v.7h-.6a1.2 1.2 0 0 0-.2 0 .5.5 0 0 0-.3.1.8.8 0 0 0-.1.3 1.6 1.6 0 0 0 0 .5v5.4a2.9 2.9 0 0 0 0 1 1.6 1.6 0 0 0 .5.6 1.7 1.7 0 0 0 .7.4 2.9 2.9 0 0 0 .8 0 2.8 2.8 0 0 0 .9 0 1.6 1.6 0 0 0 .6-.4 1.7 1.7 0 0 0 .4-.7 2.6 2.6 0 0 0 .1-.9V198a1.8 1.8 0 0 0 0-.4.6.6 0 0 0-.1-.3.6.6 0 0 0-.2-.1h-.9v-.7h3.7zm6.2 1.4c0-.2.2-.4.3-.5a4 4 0 0 0 .2-.4 1.8 1.8 0 0 0 .1-.3 1 1 0 0 0 0-.3.3.3 0 0 0-.2-.3 1.5 1.5 0 0 0-.6 0v-.8l3.8-.2v.7a1.9 1.9 0 0 0-.5.1 2.3 2.3 0 0 0-.5.3 2.9 2.9 0 0 0-.4.5l-.5.5-1.7 2.1 2.9 4a4 4 0 0 0 .4.5 1.6 1.6 0 0 0 .4.4 1.3 1.3 0 0 0 .4.1 1.6 1.6 0 0 0 .5 0v.8h-1.7a6.8 6.8 0 0 1-.6 0 2.3 2.3 0 0 1-.6-.2 1.5 1.5 0 0 1-.4-.2 1.9 1.9 0 0 1-.3-.3 4.2 4.2 0 0 1-.3-.4l-2-3-.7.4.2 2.4a2 2 0 0 0 0 .5.8.8 0 0 0 .3.2.5.5 0 0 0 .2.2 1.4 1.4 0 0 0 .3 0h.6v.7l-4.8.3-.1-.7h.9a.5.5 0 0 0 .2-.2.6.6 0 0 0 .1-.2 1.5 1.5 0 0 0 0-.5l-.4-6.8a1.6 1.6 0 0 0-.1-.4.6.6 0 0 0-.2-.2.5.5 0 0 0-.2-.2 1.3 1.3 0 0 0-.3 0h-.6v-.7l4.8-.3v.7h-.6a1 1 0 0 0-.2 0 .4.4 0 0 0-.3.2.7.7 0 0 0-.1.3 1.4 1.4 0 0 0 0 .5l.2 3.2zm7.1-1.7a2.8 2.8 0 0 1 0 .9 2.4 2.4 0 0 1-.4.8 3 3 0 0 1-.7.7 4.5 4.5 0 0 1-1.1.6v-.7a4 4 0 0 0 .4-.3 1.6 1.6 0 0 0 .4-.3 1 1 0 0 0 .2-.3.9.9 0 0 0 0-.4.3.3 0 0 0-.1-.2 1 1 0 0 0-.2 0l-.3-.2a1 1 0 0 1-.2-.2 1.1 1.1 0 0 1-.3-.3 1.2 1.2 0 0 1-.1-.4.9.9 0 0 1 .2-.8 1 1 0 0 1 .7-.3 1.2 1.2 0 0 1 1 .3 1.7 1.7 0 0 1 .4 1.1zm5.5 8a6.2 6.2 0 0 1-1.6 0 3.2 3.2 0 0 1-1-.3 1.7 1.7 0 0 1-.7-.6 1.6 1.6 0 0 1-.2-.7 1.3 1.3 0 0 1 0-.6 1.4 1.4 0 0 1 .3-.4 1.5 1.5 0 0 1 .4-.3 2.2 2.2 0 0 1 .6-.2 3.6 3.6 0 0 0 .3 1 2 2 0 0 0 .5.7 1.6 1.6 0 0 0 .7.4 1.9 1.9 0 0 0 .8 0 2 2 0 0 0 .7-.2 1.7 1.7 0 0 0 .5-.4 1.3 1.3 0 0 0 .2-.6 1.6 1.6 0 0 0 0-.6 1.3 1.3 0 0 0-.2-.6 1.8 1.8 0 0 0-.5-.4 3.9 3.9 0 0 0-.8-.4l-1-.3a8.5 8.5 0 0 1-1.4-.4 3.5 3.5 0 0 1-.9-.6 2.4 2.4 0 0 1-.5-.7 2.8 2.8 0 0 1-.3-.9 2.4 2.4 0 0 1 0-1.2 2.5 2.5 0 0 1 .7-1 3.2 3.2 0 0 1 1-.7 4.6 4.6 0 0 1 1.3-.4 5.7 5.7 0 0 1 1.3 0 3.1 3.1 0 0 1 1 .1 1.5 1.5 0 0 1 .6.5 1.2 1.2 0 0 1 .3.6 1 1 0 0 1 0 .5 1.1 1.1 0 0 1-.2.4 1.9 1.9 0 0 1-.5.3 2.8 2.8 0 0 1-.8.2 2.6 2.6 0 0 0-.2-.6 2.1 2.1 0 0 0-.3-.6 1.4 1.4 0 0 0-.5-.4 1.2 1.2 0 0 0-.7-.1 1.5 1.5 0 0 0-.5.1 1.2 1.2 0 0 0-.4.3 1.1 1.1 0 0 0-.3.5 1.3 1.3 0 0 0 0 .5 1.4 1.4 0 0 0 .2.6 1.5 1.5 0 0 0 .4.4 3.2 3.2 0 0 0 .8.4 10.9 10.9 0 0 0 1.2.4 7.4 7.4 0 0 1 1.3.4 3.8 3.8 0 0 1 1 .5 2.1 2.1 0 0 1 .5.7 2.7 2.7 0 0 1 .3 1 2.8 2.8 0 0 1-.1 1.2 2.7 2.7 0 0 1-.6 1 3.7 3.7 0 0 1-1.1.9 5.4 5.4 0 0 1-1.6.5z" />
							<path
								d="M70.2 254a169.8 169.8 0 0 1 93.7 10.6 170 170 0 0 0 102.9 8.7v-38.5a170 170 0 0 1-103-8.7 170 170 0 0 0-93.6-10.7"
								fill="#feca98"
							/>
							<path d="M88.8 227l2.2 5.2.3.6.2.6.2.6.1.4.1-.5.1-.7.1-.7.1-.7.6-3v-.5a1.5 1.5 0 0 0 0-.2v-.1a.6.6 0 0 0-.3-.5 1.1 1.1 0 0 0-.7-.1h-.3v-.7l3.7-.3v.8h-.3a1.7 1.7 0 0 0-.4 0 .5.5 0 0 0-.2.2 1.1 1.1 0 0 0-.2.3 5.4 5.4 0 0 0-.2.6l-1.6 8.3-1.6.1-2.7-6.4-1.6 6.7-1.7.1-3.1-8.3a1.6 1.6 0 0 0-.2-.4.8.8 0 0 0-.2-.2 1 1 0 0 0-.3-.1 1.4 1.4 0 0 0-.4 0h-.1v-.7l4.6-.3v.7h-.3a1 1 0 0 0-.6.2.6.6 0 0 0-.2.5 2.9 2.9 0 0 0 0 .4l.2.4 1.1 3.1.2.6.2.6.2.6.1.6.2-1c0-.3 0-.5.2-.7l1.4-6.1zm16.7 4.6a6.6 6.6 0 0 1-.3 2.1 4.3 4.3 0 0 1-1 1.6 4 4 0 0 1-1.5 1 5.1 5.1 0 0 1-2 .4 5.5 5.5 0 0 1-2-.4 3.9 3.9 0 0 1-1.5-1 4.4 4.4 0 0 1-.9-1.7 7.4 7.4 0 0 1-.2-2.1 7 7 0 0 1 .3-2.1 4.3 4.3 0 0 1 .9-1.7 3.9 3.9 0 0 1 1.5-1 5.5 5.5 0 0 1 2-.3 5.2 5.2 0 0 1 2 .4 4 4 0 0 1 1.5 1 4.5 4.5 0 0 1 1 1.7 6.7 6.7 0 0 1 .2 2.1zm-7.1 0a10.9 10.9 0 0 0 .1 1.7 4.3 4.3 0 0 0 .4 1.3 2 2 0 0 0 .7.9 2 2 0 0 0 1.1.3 2 2 0 0 0 1.1-.3 2 2 0 0 0 .8-.8 4.5 4.5 0 0 0 .4-1.3 11.8 11.8 0 0 0 .2-1.8 12.3 12.3 0 0 0-.1-1.8 4.6 4.6 0 0 0-.4-1.3 2.3 2.3 0 0 0-.7-.9 2 2 0 0 0-1.1-.3 2 2 0 0 0-1.2.3 2 2 0 0 0-.7.8 4.2 4.2 0 0 0-.5 1.3 11.6 11.6 0 0 0-.1 1.8zm7.9 4.4h.6a.9.9 0 0 0 .3 0 .5.5 0 0 0 .2-.2.6.6 0 0 0 .2-.2 1.2 1.2 0 0 0 .1-.4l.5-6.8a1.5 1.5 0 0 0 0-.5.7.7 0 0 0-.1-.3.5.5 0 0 0-.2 0l-.3-.2h-.6v-.7l4.6.3a5 5 0 0 1 2.8 1 2.2 2.2 0 0 1 .8 2 2.8 2.8 0 0 1-.3 1 2.5 2.5 0 0 1-.4.6 2.6 2.6 0 0 1-.7.5 4.5 4.5 0 0 1-.7.4l1.4 3a4.3 4.3 0 0 0 .3.5 2.5 2.5 0 0 0 .4.4 1.3 1.3 0 0 0 .3.2 1.2 1.2 0 0 0 .4.1v.7h-1.6a3.3 3.3 0 0 1-.8-.3 1.8 1.8 0 0 1-.6-.5 2.9 2.9 0 0 1-.4-.6l-1.4-3.2-1-.1-.2 2.8a1.4 1.4 0 0 0 0 .4.6.6 0 0 0 .2.3.5.5 0 0 0 .2.1 1.1 1.1 0 0 0 .3 0h.6l-.1.7-4.8-.3zm3.9-4.2h.8a2 2 0 0 0 .8 0 1.2 1.2 0 0 0 .5-.4 1.8 1.8 0 0 0 .4-.6 5.1 5.1 0 0 0 .1-.9 4.3 4.3 0 0 0 0-.9 1.5 1.5 0 0 0-.3-.6 1.2 1.2 0 0 0-.5-.4 2.4 2.4 0 0 0-.7-.1l-.8-.1z" />
							<path d="M122.5 230.8l.4-.4a2 2 0 0 0 .3-.3 1.7 1.7 0 0 0 .2-.3 1 1 0 0 0 0-.3.3.3 0 0 0 0-.4 1.5 1.5 0 0 0-.6-.1v-.7l3.8.5v.7a1.7 1.7 0 0 0-.6 0 2.4 2.4 0 0 0-.6.2 3 3 0 0 0-.5.3l-.5.4-2.1 1.8 2 4.4a4 4 0 0 0 .3.6 2.2 2.2 0 0 0 .3.4 1.2 1.2 0 0 0 .4.2 1.6 1.6 0 0 0 .4.2l-.1.7-.8-.1-.9-.2a6.5 6.5 0 0 1-.7-.2 2.2 2.2 0 0 1-.5-.2 1.7 1.7 0 0 1-.3-.3 2.3 2.3 0 0 1-.3-.4l-.2-.4-1.4-3.4-.7.4-.3 2.3a1.6 1.6 0 0 0 0 .5.6.6 0 0 0 .1.3.5.5 0 0 0 .2.1 1.3 1.3 0 0 0 .3.1h.6l-.1.8-4.8-.6.1-.8.6.1h.3a.5.5 0 0 0 .2 0 .6.6 0 0 0 .2-.3 1.6 1.6 0 0 0 .1-.4l1-6.8a1.4 1.4 0 0 0 0-.4.6.6 0 0 0-.2-.3.5.5 0 0 0-.2-.2 1.1 1.1 0 0 0-.3 0l-.6-.1.1-.7 4.8.6v.7h-.7a1.4 1.4 0 0 0-.2 0 .5.5 0 0 0-.3 0 .7.7 0 0 0-.2.3 1.8 1.8 0 0 0-.1.5l-.4 3.2zm12.5 2.6a3.4 3.4 0 0 1-.4 1.1 2.6 2.6 0 0 1-.9 1 3.5 3.5 0 0 1-1.4.4 6 6 0 0 1-1.9-.1l-.5-.1-.4 2.2a1.4 1.4 0 0 0 0 .4.6.6 0 0 0 .3.5h.3l.9.2-.2.7-5-1 .2-.7.5.1h.3a.5.5 0 0 0 .3 0 .7.7 0 0 0 .2-.3 1.5 1.5 0 0 0 .1-.5l1.3-6.6a1.2 1.2 0 0 0 0-.5.5.5 0 0 0-.1-.2.5.5 0 0 0-.2-.2 1 1 0 0 0-.3 0l-.6-.2.2-.7 4.2.8a5.9 5.9 0 0 1 1.6.5 3.2 3.2 0 0 1 1 .8 2.4 2.4 0 0 1 .6 1 3.1 3.1 0 0 1 0 1.4zm-5 1.5h.4a2.5 2.5 0 0 0 .9 0 1.3 1.3 0 0 0 .6-.3 1.7 1.7 0 0 0 .5-.6 4.9 4.9 0 0 0 .3-1 4.4 4.4 0 0 0 .1-1 1.8 1.8 0 0 0-.2-.7 1.2 1.2 0 0 0-.4-.5 2.3 2.3 0 0 0-.7-.3l-.6-.1zm4.3 5.5l.2-.7.5.1a1.6 1.6 0 0 0 .3 0 .4.4 0 0 0 .3 0 .7.7 0 0 0 .2-.3 1.7 1.7 0 0 0 .1-.4l1.7-6.5a1.5 1.5 0 0 0 0-.5.6.6 0 0 0 0-.3.5.5 0 0 0-.3-.2.8.8 0 0 0-.2 0l-.6-.2.2-.7 4.7 1.2-.2.7-.6-.2h-.2a.4.4 0 0 0-.3 0 .6.6 0 0 0-.2.3 1.4 1.4 0 0 0-.2.4l-1.8 7.3 2.5.7a1 1 0 0 0 .9-.1 1.9 1.9 0 0 0 .6-.8l.4-1 .8.2-.9 3zm12.1-.2l-.7 1-.3.3a1.7 1.7 0 0 0-.1.4.4.4 0 0 0 0 .3.4.4 0 0 0 0 .2.9.9 0 0 0 .2.1.7.7 0 0 0 .2.1l.6.2-.2.7-3.5-1 .2-.8h.2a1.5 1.5 0 0 0 .3 0 .7.7 0 0 0 .3 0 1.2 1.2 0 0 0 .4-.2 3.4 3.4 0 0 0 .3-.4l5.4-7 1.8.5.4 8.8a3.7 3.7 0 0 0 0 .5 1.6 1.6 0 0 0 .2.4.8.8 0 0 0 .2.2 1 1 0 0 0 .3.1l.2.1-.2.7-4.4-1.3.2-.8.5.2a.8.8 0 0 0 .5 0 .8.8 0 0 0 .1-.1.7.7 0 0 0 .2-.2 1 1 0 0 0 0-.4 1.3 1.3 0 0 0 0-.2V241zm3.2-2.3v-2.2l-.3.4-.3.5-.3.4-.3.5-1.5 2 2.7.8zm8.4 8.7a3.3 3.3 0 0 0 .9.2 3 3 0 0 0 1.4-.3l.6-.3a.7.7 0 0 1 0 .3.8.8 0 0 1 0 .4 1.3 1.3 0 0 1-.4.5 1.7 1.7 0 0 1-.7.4 3.3 3.3 0 0 1-1 0 5.4 5.4 0 0 1-1.5-.3 5.8 5.8 0 0 1-1.9-1 4 4 0 0 1-1-1.6 4.3 4.3 0 0 1-.2-1.8 6.8 6.8 0 0 1 .4-2.1 6.6 6.6 0 0 1 1-1.9 4.5 4.5 0 0 1 1.4-1.1 4 4 0 0 1 1.8-.5 5.3 5.3 0 0 1 2 .4 7.2 7.2 0 0 1 1.3.6 3.8 3.8 0 0 1 .9.7 1.7 1.7 0 0 1 .3.7 1.2 1.2 0 0 1 0 .7 1 1 0 0 1-.2.4 1 1 0 0 1-.5.2 1.6 1.6 0 0 1-.6 0 2.5 2.5 0 0 1-.7-.2 3.2 3.2 0 0 0 .1-.6 1.7 1.7 0 0 0 0-.7 1.4 1.4 0 0 0-.2-.6 1.6 1.6 0 0 0-.7-.4 2.2 2.2 0 0 0-1.1-.1 2 2 0 0 0-1 .5 4.3 4.3 0 0 0-.8 1 12.3 12.3 0 0 0-.8 1.7 9.3 9.3 0 0 0-.5 1.7 3.4 3.4 0 0 0 0 1.4 2 2 0 0 0 .6 1 3.1 3.1 0 0 0 1.1.7zm6.7 2.8l2.6 1a.8.8 0 0 0 .3 0 .9.9 0 0 0 .4 0 1 1 0 0 0 .2-.3 2 2 0 0 0 .3-.4l.3-.6 1 .4-1 2.4-7.7-3 .3-.7.5.2h.3a.6.6 0 0 0 .2 0 .5.5 0 0 0 .3-.1 1.2 1.2 0 0 0 .2-.4l2.5-6.3a1.9 1.9 0 0 0 0-.5.6.6 0 0 0 0-.3.5.5 0 0 0 0-.2 1.3 1.3 0 0 0-.3-.1l-.6-.2.3-.7 7.2 2.8-.9 2.5-.9-.4.2-.6a1.6 1.6 0 0 0 0-.9.8.8 0 0 0-.5-.5l-2.2-.8-1.3 3.2 3.1 1.2-.3.8-3-1.2zm8.9 3.4l.6.2a1.5 1.5 0 0 0 .2 0 .6.6 0 0 0 .3 0 .7.7 0 0 0 .2-.1 1.3 1.3 0 0 0 .2-.4l2-6.6a1.2 1.2 0 0 0 0-.4.5.5 0 0 0 0-.3.4.4 0 0 0-.2-.2 1.1 1.1 0 0 0-.3 0l-.5-.3.2-.7 4.3 1.4a5 5 0 0 1 2.6 1.4 2.2 2.2 0 0 1 .3 2.2 2.6 2.6 0 0 1-.4.9 2.5 2.5 0 0 1-.7.6 3 3 0 0 1-.7.3 4.3 4.3 0 0 1-.8.1l.8 3.3a3.8 3.8 0 0 0 .2.6 2 2 0 0 0 .2.4 1.3 1.3 0 0 0 .2.3 1.4 1.4 0 0 0 .4.2l-.2.7-.4-.2c-.4 0-.8-.2-1-.3a3.8 3.8 0 0 1-.7-.4 1.9 1.9 0 0 1-.5-.6 2.5 2.5 0 0 1-.3-.7l-.7-3.5-.8-.2-.9 2.6a1.3 1.3 0 0 0 0 .4.6.6 0 0 0 0 .3.5.5 0 0 0 .2.2l.3.1.6.2-.3.7-4.6-1.4zm4.6-3.1l.8.2a2.2 2.2 0 0 0 .8.1 1.2 1.2 0 0 0 .6-.2 1.6 1.6 0 0 0 .5-.6 4.3 4.3 0 0 0 .3-.8 3.8 3.8 0 0 0 .2-.9 1.4 1.4 0 0 0-.1-.6 1.1 1.1 0 0 0-.4-.5 2.7 2.7 0 0 0-.8-.4l-.7-.2zm15.4 4.3a6.9 6.9 0 0 1-.8 2 4.6 4.6 0 0 1-1.3 1.3 4.1 4.1 0 0 1-1.6.6 5 5 0 0 1-2 0 5.5 5.5 0 0 1-2-1 4 4 0 0 1-1.2-1.3 4.5 4.5 0 0 1-.5-1.8 7.3 7.3 0 0 1 .2-2.1 7.4 7.4 0 0 1 .8-2 4.4 4.4 0 0 1 1.2-1.4 4 4 0 0 1 1.7-.6 5.6 5.6 0 0 1 2.1.1 5.3 5.3 0 0 1 2 .8 4 4 0 0 1 1.1 1.4 4.5 4.5 0 0 1 .5 1.8 6.7 6.7 0 0 1-.2 2.1zm-7-1.8a12 12 0 0 0-.2 1.8 4.3 4.3 0 0 0 0 1.4 2 2 0 0 0 .6 1 2.3 2.3 0 0 0 2.2.5 2.1 2.1 0 0 0 .9-.6 4.7 4.7 0 0 0 .7-1.2 12.4 12.4 0 0 0 .5-1.7 11.2 11.2 0 0 0 .3-1.8 4.6 4.6 0 0 0 0-1.4 2.1 2.1 0 0 0-.6-1 2 2 0 0 0-1-.5 2 2 0 0 0-1.1 0 2 2 0 0 0-1 .6 4.3 4.3 0 0 0-.7 1.2 11.1 11.1 0 0 0-.5 1.7zm15.2 8.3l.2-.8h.1a1.8 1.8 0 0 0 .4 0 .7.7 0 0 0 .3 0 .5.5 0 0 0 .2-.2 1 1 0 0 0 .1-.4l1.2-7-4.2 8-1-.2-1.5-9-1.1 6.9a1.2 1.2 0 0 0 0 .5.7.7 0 0 0 .1.3.8.8 0 0 0 .3.2 2.5 2.5 0 0 0 .5 0v.8l-3.5-.6.1-.7h1a.5.5 0 0 0 .2 0 .5.5 0 0 0 .2-.2 1.6 1.6 0 0 0 .1-.4l1.2-6.8a1.8 1.8 0 0 0 0-.4.5.5 0 0 0-.3-.5 1 1 0 0 0-.3 0l-.6-.1.1-.8 4 .7 1.2 7.2 3.3-6.3 4 .7-.2.7-.6-.1a1.3 1.3 0 0 0-.3 0 .4.4 0 0 0-.2 0 .7.7 0 0 0-.2.3 1.7 1.7 0 0 0-.1.5l-1.1 6.6a1.4 1.4 0 0 0 0 .5.8.8 0 0 0 0 .3.6.6 0 0 0 .3.1l.2.1h.6l-.1.8zm8.6-2.2l-.5 1.2a4 4 0 0 0-.2.4 1.4 1.4 0 0 0-.1.3.5.5 0 0 0 0 .3.5.5 0 0 0 .1.2.8.8 0 0 0 .5.1l.5.1v.7l-3.7-.3.1-.7h.2a1.3 1.3 0 0 0 .3 0 .6.6 0 0 0 .3-.2 1.3 1.3 0 0 0 .3-.3 3.2 3.2 0 0 0 .3-.4l3.8-8 2 .2 2 8.5a3.5 3.5 0 0 0 .2.5 1.3 1.3 0 0 0 .2.4.8.8 0 0 0 .3.2 1 1 0 0 0 .3 0h.3l-.1.8-4.6-.5v-.7h.8a.7.7 0 0 0 .2 0 .5.5 0 0 0 .2-.2.4.4 0 0 0 0-.2 1.2 1.2 0 0 0 0-.4v-.2l-.3-1.5zm2.6-2.9v-.5l-.2-.6v-.5l-.1-.6-.2.5c0 .2-.2.3-.3.5l-.2.5-.2.5-1 2.3 2.8.2zm13 7.2l-5.2-7.9-.2 6a1.6 1.6 0 0 0 0 .6.8.8 0 0 0 .2.2.5.5 0 0 0 .2.2 1.3 1.3 0 0 0 .3 0h.5v.7l-3.6-.1v-.8h.8a.5.5 0 0 0 .3 0 .6.6 0 0 0 .1-.3 1.5 1.5 0 0 0 .1-.5l.2-6.8a1.4 1.4 0 0 0 0-.4.6.6 0 0 0-.2-.3.5.5 0 0 0-.2-.1 1.1 1.1 0 0 0-.3 0h-.5v-.7h3l4.8 7.2.1-5.4a1.5 1.5 0 0 0 0-.4.7.7 0 0 0-.1-.3.6.6 0 0 0-.2-.1h-.9v-.8l3.7.2v.7h-.6a.8.8 0 0 0-.3 0 .5.5 0 0 0-.2.1.6.6 0 0 0-.2.3 1.7 1.7 0 0 0 0 .5l-.3 8.3zm9-1.1a3 3 0 0 0 1-.1 3.3 3.3 0 0 0 .7-.3 3 3 0 0 0 .5-.5 5.7 5.7 0 0 0 .4-.5.6.6 0 0 1 .2.3.8.8 0 0 1 0 .3 1.4 1.4 0 0 1 0 .7 1.7 1.7 0 0 1-.6.6 3 3 0 0 1-1 .4 5.5 5.5 0 0 1-1.5.3 5.7 5.7 0 0 1-2.1-.4 4 4 0 0 1-1.5-1 4.3 4.3 0 0 1-1-1.6 7.3 7.3 0 0 1-.1-4.1 4.5 4.5 0 0 1 .9-1.7 4 4 0 0 1 1.5-1 5.4 5.4 0 0 1 2-.5 6.8 6.8 0 0 1 1.5 0 3.8 3.8 0 0 1 1 .4 1.7 1.7 0 0 1 .6.5 1.2 1.2 0 0 1 .2.6 1 1 0 0 1-.1.5 1.2 1.2 0 0 1-.3.4 2 2 0 0 1-.6.3 3.3 3.3 0 0 1-.7 0 3.3 3.3 0 0 0-.1-.6 1.8 1.8 0 0 0-.3-.6 1.4 1.4 0 0 0-1.2-.6 2.1 2.1 0 0 0-1.1.3 2.1 2.1 0 0 0-.8.8 4.7 4.7 0 0 0-.3 1.4 11.3 11.3 0 0 0-.1 1.8 9.6 9.6 0 0 0 .2 1.7 3.6 3.6 0 0 0 .5 1.3 2.1 2.1 0 0 0 1 .7 3 3 0 0 0 1.3.2zm7.6-.3l2.8-.2a.7.7 0 0 0 .4-.1.7.7 0 0 0 .2-.2 1 1 0 0 0 .2-.4 3 3 0 0 0 0-.4v-.7h1l.2 2.5-8.2.7v-.8h.8a.5.5 0 0 0 .2-.2.5.5 0 0 0 .2-.2 1.2 1.2 0 0 0 0-.5l-.6-6.7a2 2 0 0 0 0-.5.7.7 0 0 0-.3-.3.4.4 0 0 0-.2 0 1.4 1.4 0 0 0-.3 0h-.6v-.8l7.7-.6.3 2.5-1 .1-.1-.6a1.6 1.6 0 0 0-.3-.8.7.7 0 0 0-.7-.2l-2.3.2.3 3.5 3.3-.3v.9l-3.2.2zm9.2.1a6.2 6.2 0 0 1-1.5 0 3 3 0 0 1-1-.4 1.6 1.6 0 0 1-.7-.5 1.8 1.8 0 0 1-.2-.7 1.3 1.3 0 0 1 0-.6 1 1 0 0 1 .3-.4 1.3 1.3 0 0 1 .5-.3 2.6 2.6 0 0 1 .6-.2 3.6 3.6 0 0 0 .3 1 2.2 2.2 0 0 0 .5.7 1.6 1.6 0 0 0 .6.4 1.9 1.9 0 0 0 .8 0 2 2 0 0 0 .7-.2 1.5 1.5 0 0 0 .5-.4 1.4 1.4 0 0 0 .3-1.1 1.3 1.3 0 0 0-.2-.7 1.7 1.7 0 0 0-.5-.4 3.7 3.7 0 0 0-.8-.3l-1-.4a8.1 8.1 0 0 1-1.4-.4 3.9 3.9 0 0 1-.9-.6 2.6 2.6 0 0 1-.5-.7 3.2 3.2 0 0 1-.3-1 2.6 2.6 0 0 1 .1-1.1 2.6 2.6 0 0 1 .6-1 3.2 3.2 0 0 1 1-.7 4.3 4.3 0 0 1 1.4-.4 5.7 5.7 0 0 1 1.3 0 2.8 2.8 0 0 1 1 .2 1.5 1.5 0 0 1 .6.4 1.3 1.3 0 0 1 .3.6 1 1 0 0 1 0 .5 1 1 0 0 1-.3.4 1.8 1.8 0 0 1-.5.3 3.2 3.2 0 0 1-.7.2 3.1 3.1 0 0 0-.2-.6 2.5 2.5 0 0 0-.3-.6 1.5 1.5 0 0 0-.6-.4 1.3 1.3 0 0 0-.7-.1 1.9 1.9 0 0 0-.5.1 1 1 0 0 0-.4.3 1.1 1.1 0 0 0-.2.5 1.5 1.5 0 0 0 0 .5 1.8 1.8 0 0 0 .1.6 1.4 1.4 0 0 0 .5.4 2.8 2.8 0 0 0 .7.4 10.7 10.7 0 0 0 1.2.4 8.4 8.4 0 0 1 1.3.4 3.7 3.7 0 0 1 1 .6 2.4 2.4 0 0 1 .5.7 2.8 2.8 0 0 1 .3.9 3 3 0 0 1-.1 1.3 2.7 2.7 0 0 1-.7 1 3.6 3.6 0 0 1-1 .8 5.3 5.3 0 0 1-1.8.6z" />
							<path
								d="M80.6 85.1v-2.4h1.9a3.9 3.9 0 0 0 .9 0 1.5 1.5 0 0 0 .7-.5 2 2 0 0 0 .5-.9 5.3 5.3 0 0 0 .2-1.5v-10H73.1v10a5.3 5.3 0 0 0 .1 1.5 2.3 2.3 0 0 0 .5 1 1.5 1.5 0 0 0 .8.3 3.9 3.9 0 0 0 .9.1h1.9v2.4H61.8v-2.4h1.9a3.9 3.9 0 0 0 .8 0 1.5 1.5 0 0 0 .8-.5 2 2 0 0 0 .5-.9 5.4 5.4 0 0 0 .2-1.5V58.1a4.4 4.4 0 0 0-.2-1.4 2 2 0 0 0-.5-.8 1.6 1.6 0 0 0-.7-.4 3.7 3.7 0 0 0-1-.1h-1.8V53h15.5v2.4h-2a3.9 3.9 0 0 0-.8.1 1.5 1.5 0 0 0-.8.4 2.3 2.3 0 0 0-.5.9 5 5 0 0 0-.1 1.5V67h11.7v-8.7a5 5 0 0 0-.2-1.5 2 2 0 0 0-.5-1 1.5 1.5 0 0 0-.7-.3 3.9 3.9 0 0 0-.9-.1h-2V53h15.6v2.4h-1.9a3.6 3.6 0 0 0-.9.1 1.5 1.5 0 0 0-.7.4 2 2 0 0 0-.5.9 5 5 0 0 0-.2 1.5V80a4.3 4.3 0 0 0 .2 1.4 1.8 1.8 0 0 0 .5.8 1.7 1.7 0 0 0 .7.4 4.1 4.1 0 0 0 1 0H96v2.5zM122.4 73q0 6.4-3 9.5t-8.8 3a14.3 14.3 0 0 1-4.8-.7 9.4 9.4 0 0 1-3.7-2.3 10.1 10.1 0 0 1-2.3-4A17.3 17.3 0 0 1 99 73q0-6.3 3-9.4c2-2.1 5-3.1 8.8-3.1a14 14 0 0 1 4.8.7 9.4 9.4 0 0 1 3.7 2.4 10.1 10.1 0 0 1 2.3 3.9 17 17 0 0 1 .8 5.5zM106 73a31.4 31.4 0 0 0 .3 4.2 10.9 10.9 0 0 0 .8 3 4.3 4.3 0 0 0 1.4 2 3.7 3.7 0 0 0 2.2.6 3.6 3.6 0 0 0 2.2-.7 4.3 4.3 0 0 0 1.5-1.8 10.9 10.9 0 0 0 .8-3 33 33 0 0 0 .2-4.3 31.5 31.5 0 0 0-.2-4.2 10.4 10.4 0 0 0-.9-3A4.2 4.2 0 0 0 113 64a4.3 4.3 0 0 0-4.4 0 4.2 4.2 0 0 0-1.5 1.7 10.8 10.8 0 0 0-.8 3 30.8 30.8 0 0 0-.2 4.3zm40.3-11.8l4.4 13.3a24.1 24.1 0 0 1 .8 2.8l.3 2h.2l.2-1.1.3-1 .3-1.3c0-.5.2-.9.4-1.5l2-6.5a10 10 0 0 0 .3-1.3 6.7 6.7 0 0 0 .1-1 2 2 0 0 0-.7-1.6 3.9 3.9 0 0 0-2.3-.6h-.3V61h10.3v2.4h-.6a4 4 0 0 0-1.1.1 2 2 0 0 0-.9.5 4.3 4.3 0 0 0-.7 1 14.3 14.3 0 0 0-.7 1.9L152.8 85H148l-5-15-5 15h-5l-5.8-19.4a5.6 5.6 0 0 0-.5-1.1 2.4 2.4 0 0 0-1.5-1.1 5.5 5.5 0 0 0-1.2-.1h-.1V61h13.2v2.4h-.6a4.2 4.2 0 0 0-2 .4 1.6 1.6 0 0 0-.7 1.5 4.6 4.6 0 0 0 .1.9l.3 1 1.7 5.8.4 1.7c0 .6.2 1.1.3 1.6l.4 1.6.2 1.3h.1a28.4 28.4 0 0 1 1.5-5.2l4.6-12.8zm28.3 21.5a5.4 5.4 0 0 0 1.1 0 2.5 2.5 0 0 0 1.8-1.4 3.2 3.2 0 0 0 .3-1.5V56a2.9 2.9 0 0 0-.3-1.4 2.5 2.5 0 0 0-.8-.8 2.8 2.8 0 0 0-1-.4 5.5 5.5 0 0 0-1-.1h-.5v-2.4h10.5v28.9a3 3 0 0 0 .4 1.5 2.5 2.5 0 0 0 .7 1 2.6 2.6 0 0 0 1 .3 5.4 5.4 0 0 0 1.1.1h.5v2.4h-14.3v-2.4zm39.6-9.7q0 6.4-3 9.5t-8.8 3a14.3 14.3 0 0 1-4.8-.7 9.3 9.3 0 0 1-3.6-2.4 10.4 10.4 0 0 1-2.3-3.9 17.6 17.6 0 0 1-.8-5.5q0-6.4 3-9.5t8.8-3a14 14 0 0 1 4.8.7 9.4 9.4 0 0 1 3.7 2.3 10.4 10.4 0 0 1 2.3 4 17.4 17.4 0 0 1 .7 5.5zm-16.4 0a31.4 31.4 0 0 0 .3 4.2 10.8 10.8 0 0 0 .8 3 4.3 4.3 0 0 0 1.5 2 3.8 3.8 0 0 0 2.1.6 3.6 3.6 0 0 0 2.2-.7 4.4 4.4 0 0 0 1.5-1.8 11.2 11.2 0 0 0 .8-3 33 33 0 0 0 .2-4.3 31.5 31.5 0 0 0-.2-4.2 11.2 11.2 0 0 0-.8-3 4 4 0 0 0-7.3 0 11.2 11.2 0 0 0-.8 3 33.2 33.2 0 0 0-.3 4.2zm45.3-9.6h-.9a3 3 0 0 0-.8 0 1.8 1.8 0 0 0-.7.5 4 4 0 0 0-.7 1 17.6 17.6 0 0 0-.7 1.8L232.8 85h-6l-7.3-19.5a3.9 3.9 0 0 0-.6-1.1 2.5 2.5 0 0 0-.8-.7 3.2 3.2 0 0 0-1-.3 8.2 8.2 0 0 0-1.3-.1V61h14v2.4h-1.9a1.6 1.6 0 0 0-1 .4 1.4 1.4 0 0 0-.5 1 4 4 0 0 0 .1 1.1l.3.9 3 8.5 1 2.9a22 22 0 0 1 .6 2.6l.3-1.2.5-1.4.3-1.2.2-.8 3-9 .5-1.2a5.8 5.8 0 0 0 0-1.2 1 1 0 0 0-.4-1 2.6 2.6 0 0 0-1.3-.3h-1.3V61h10zm13.3 22.1a14 14 0 0 1-5-.8 9.6 9.6 0 0 1-3.6-2.4 10.2 10.2 0 0 1-2.2-3.9 17 17 0 0 1-.8-5.2 18.3 18.3 0 0 1 .8-5.6 10.8 10.8 0 0 1 2.1-4 9 9 0 0 1 3.6-2.4 14.3 14.3 0 0 1 9 0 8.7 8.7 0 0 1 3.4 2 9.1 9.1 0 0 1 2 3.3 13.9 13.9 0 0 1 .8 4.7v2.3h-14.8a17.6 17.6 0 0 0 .5 3.9 8.2 8.2 0 0 0 1.2 2.7 4.7 4.7 0 0 0 1.9 1.5 5.9 5.9 0 0 0 2.4.5 7.8 7.8 0 0 0 2.2-.2 7 7 0 0 0 1.8-.8A6.3 6.3 0 0 0 263 80a6.5 6.5 0 0 0 1-1.4 2.3 2.3 0 0 1 1.2 2.2 3.5 3.5 0 0 1-.5 1.8 4.5 4.5 0 0 1-1.6 1.5 9.7 9.7 0 0 1-2.8 1 17.5 17.5 0 0 1-4 .5zm-.4-22.2a3.4 3.4 0 0 0-3 2 11.5 11.5 0 0 0-1.2 5.4h7.8a21.1 21.1 0 0 0-.2-3.1 8.4 8.4 0 0 0-.7-2.3 3.5 3.5 0 0 0-1-1.4 2.6 2.6 0 0 0-1.7-.6zm-138.5 51.9l4.4 13.3a24.1 24.1 0 0 1 .7 2.8l.5 2 .3-1.1.2-1 .4-1.3.4-1.5 2-6.5.3-1.3a5.6 5.6 0 0 0 .1-1 2 2 0 0 0-.7-1.6 3.9 3.9 0 0 0-2.3-.6h-.3V115h10.3v2.4h-.6a4 4 0 0 0-1.1.1 2 2 0 0 0-.9.5 4.3 4.3 0 0 0-.7 1.1 14.3 14.3 0 0 0-.6 1.8l-5.9 18.2h-4.9l-4.9-15-5.1 15h-5l-5.7-19.3a5.6 5.6 0 0 0-.6-1.2 2.4 2.4 0 0 0-.6-.7 2.5 2.5 0 0 0-.9-.4 5.4 5.4 0 0 0-1.1-.1H95V115h13.2v2.4h-.6a4 4 0 0 0-2 .4 1.6 1.6 0 0 0-.7 1.5 4.6 4.6 0 0 0 .1.9l.3 1 1.7 5.8.4 1.7c0 .6.2 1.1.4 1.7l.3 1.5.2 1.3h.1a24.8 24.8 0 0 1 1.5-5.2l4.6-12.8zm41.3 11.8q0 6.4-3 9.5c-2 2-5 3-8.8 3a14.3 14.3 0 0 1-4.8-.7 9.3 9.3 0 0 1-3.7-2.3 10.3 10.3 0 0 1-2.3-4 17.6 17.6 0 0 1-.8-5.5q0-6.3 3-9.4c2-2.1 4.9-3.1 8.8-3.1a14 14 0 0 1 4.8.7 9.4 9.4 0 0 1 3.7 2.4 10.2 10.2 0 0 1 2.3 3.9 17 17 0 0 1 .8 5.5zm-16.4 0a31.4 31.4 0 0 0 .3 4.2 11.3 11.3 0 0 0 .8 3 4.3 4.3 0 0 0 1.4 2 4.1 4.1 0 0 0 4.4 0 4.5 4.5 0 0 0 1.5-2 11.2 11.2 0 0 0 .8-3 33 33 0 0 0 .2-4.2 31.5 31.5 0 0 0-.3-4.2 11.2 11.2 0 0 0-.8-3 4 4 0 0 0-5.8-1.8 4.3 4.3 0 0 0-1.5 1.8 10.8 10.8 0 0 0-.8 3 33.2 33.2 0 0 0-.2 4.2zm34 12.1h-15v-2.4a9.3 9.3 0 0 0 1.5 0 2.4 2.4 0 0 0 1-.5 2.2 2.2 0 0 0 .8-1 4.6 4.6 0 0 0 .3-1.7v-13a4.5 4.5 0 0 0-.3-1.6 2 2 0 0 0-.6-1 2.3 2.3 0 0 0-1-.4 8.5 8.5 0 0 0-1.4 0h-.1V115h9l1 3.5h.2a10.3 10.3 0 0 1 1-1.8 5 5 0 0 1 1.3-1.2 5.3 5.3 0 0 1 1.7-.8 10 10 0 0 1 2.4-.2 6.5 6.5 0 0 1 3.9 1 3.1 3.1 0 0 1 1.3 2.6 3.8 3.8 0 0 1-1.5 3.2 6.9 6.9 0 0 1-4.3 1.2 14.8 14.8 0 0 0 0-1.7 3.4 3.4 0 0 0-.4-1.1 1.6 1.6 0 0 0-.7-.7 2.2 2.2 0 0 0-1-.3 2.4 2.4 0 0 0-1.4.4 3.4 3.4 0 0 0-1 1 5.7 5.7 0 0 0-.7 1.5 12.3 12.3 0 0 0-.4 1.5 13.3 13.3 0 0 0-.2 1.6v9a4.1 4.1 0 0 0 .3 1.6 2 2 0 0 0 .6 1 2.3 2.3 0 0 0 1 .3 7.4 7.4 0 0 0 1.3.1h1.4zm35.7 0h-4.7a12.8 12.8 0 0 1-3-.6 5.5 5.5 0 0 1-2-1.2 10.8 10.8 0 0 1-1.8-2.2l-4-6.3-1.7 1.3v3.7a3.2 3.2 0 0 0 .3 1.5 2.5 2.5 0 0 0 1.8 1.3 5.3 5.3 0 0 0 1 .1h.5v2.4h-14.3v-2.4h.5a5.4 5.4 0 0 0 1 0 2.6 2.6 0 0 0 1-.5 2.5 2.5 0 0 0 .9-.9 3 3 0 0 0 .3-1.5V110a2.7 2.7 0 0 0-.3-1.4 2.4 2.4 0 0 0-.8-.8 2.8 2.8 0 0 0-1-.4 5.5 5.5 0 0 0-1-.1h-.6v-2.4h10.6v18.8a11.2 11.2 0 0 1 0 1.5l-.2 1.8 5.7-6.4a6.1 6.1 0 0 0 1-1.3 2 2 0 0 0 .2-.8 1 1 0 0 0-.6-1 3.8 3.8 0 0 0-1.7-.2V115h11.3v2.3a6 6 0 0 0-3 .9 15.3 15.3 0 0 0-3.3 2.9l-2.8 3.2 6 9a10 10 0 0 0 2.3 2.6 4 4 0 0 0 2.3.8h.2zm9.9.5a19.4 19.4 0 0 1-4-.4 8.6 8.6 0 0 1-2.9-1.1 4.3 4.3 0 0 1-1.6-1.7 4.5 4.5 0 0 1-.5-2.1 3.2 3.2 0 0 1 .5-1.8 3.1 3.1 0 0 1 1-1 4 4 0 0 1 1.4-.5 7.4 7.4 0 0 1 1.3 0 8.3 8.3 0 0 0 .4 2.4 5.3 5.3 0 0 0 1 2 4.3 4.3 0 0 0 1.5 1.1 4.6 4.6 0 0 0 2 .5 7.5 7.5 0 0 0 2-.3 4 4 0 0 0 1.4-.6 2.7 2.7 0 0 0 1-2.2 3 3 0 0 0-.2-1.3 3.3 3.3 0 0 0-1-1.1 8.6 8.6 0 0 0-1.6-1 22 22 0 0 0-2.7-1 26.7 26.7 0 0 1-3.2-1.4 10 10 0 0 1-2.4-1.6 6.1 6.1 0 0 1-1.4-2.2 7.1 7.1 0 0 1-.5-2.7 6.7 6.7 0 0 1 .7-3.1 6.1 6.1 0 0 1 2-2.3 9.2 9.2 0 0 1 3-1.3 16.8 16.8 0 0 1 4-.4 15.7 15.7 0 0 1 3.6.3 8.7 8.7 0 0 1 2.5 1 4.1 4.1 0 0 1 1.3 1.4 3 3 0 0 1 .5 1.5 2.7 2.7 0 0 1-1.1 2.3 6 6 0 0 1-3.5.8 5.4 5.4 0 0 0-1-3.5 3.6 3.6 0 0 0-3-1.3 5.5 5.5 0 0 0-1.4.2 3.5 3.5 0 0 0-1.2.5 2.9 2.9 0 0 0-.8.9 2.4 2.4 0 0 0-.3 1.2 3 3 0 0 0 .3 1.3 3 3 0 0 0 1 1.1 10.3 10.3 0 0 0 1.9 1l3 1.2a19.9 19.9 0 0 1 2.7 1.2 9.8 9.8 0 0 1 2.2 1.5 6.2 6.2 0 0 1 1.4 2 6 6 0 0 1 .5 2.5 8.2 8.2 0 0 1-.6 3.4 6.5 6.5 0 0 1-2 2.5 8.9 8.9 0 0 1-3 1.5 14.3 14.3 0 0 1-4.1.6z"
								fill="#fff"
							/>
						</svg>
					</h1>

					<div className={s.introText} id={'intro'}>
						<p>
							How many of us are up for dating a colleague? What happens when
							passion mixes with paperwork? Do we keep it a secret or circulate
							a memo? And which jobs offer the best chance of a date? We
							surveyed more than 5,000 people to reveal the secrets of the UK’s
							work romances…
						</p>
						<p>
							<NextArrow to={'how-we-meet'} />
						</p>
						<div className={s.test}>
							<div className={s.mobileSparkles}>
								{mobileSparkles.map(heart => (
									<LoveHeart
										onMouseDown={e =>
											this.startDragging(e, heart.id, !heart.isSparkle)
										}
										onMouseUp={() => this.stopDragging(heart.id)}
										{...heart}
										isSmall
									/>
								))}
							</div>

							<div className={s.desktopSparkles}>
								{loveSparkles.map(heart => (
									<LoveHeart
										onMouseDown={e =>
											this.startDragging(e, heart.id, !heart.isSparkle)
										}
										onMouseUp={() => this.stopDragging(heart.id)}
										{...heart}
									/>
								))}
							</div>
						</div>

						<div>
							<div className={s.mobileHearts}>
								{mobileHearts.map(heart => (
									<LoveHeart
										onMouseDown={e =>
											this.startDragging(e, heart.id, !heart.isSparkle)
										}
										onMouseUp={() => this.stopDragging(heart.id)}
										{...heart}
										isSmall
									/>
								))}
							</div>

							<div className={s.desktopHearts}>
								{loveHearts.map(heart => (
									<LoveHeart
										onMouseDown={e =>
											this.startDragging(e, heart.id, !heart.isSparkle)
										}
										onMouseUp={() => this.stopDragging(heart.id)}
										{...heart}
									/>
								))}
							</div>
						</div>
					</div>
				</Container>
			</div>
		);
	}
}

export default Intro;



// WEBPACK FOOTER //
// ./components/Intro/index.js